/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Type_CodeInputs */

const vi_tea_type_code = /** @type {(inputs: Tea_Type_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã loại chè`)
};

/**

* @param {Tea_Type_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_type_code = /** @type {((inputs?: Tea_Type_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Type_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_type_code(inputs)
});